import React, { Component } from "react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PAACPM from "./PAACPM";
import PAACPW from "./PAACPW";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PAACP extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAACP.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <PAACPM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <PAACPW {...this.props} />,
    });
  }

}

export default PAACP;
